import React from "react";
import { useDispatch, useSelector } from "react-redux";

import classes from "./IconsSelect.module.css";
import BtnSelect from "../../../../UI/Buttons/BtnSelect";
import BackArrow from "../../../../UI/BackArrow";
import { messageTypeApi } from "../../../../../utils";
import { throwApiError } from "../../../../lms-shared/store/error-handling-actions";

const IconsSelect = ({ onClose, icons, onSelect, addIcon }) => {

    const { texts } = useSelector(state => state.translate);
    const dispatch = useDispatch();

    const handleClick = (id) => {
        onSelect(id);
        onClose();
    }

    const handleIconUpload = (e) => {
        if (e.target.files && e.target.files[0]) {
            messageTypeApi.messageTypeAddPost({ name: "icon", icon: e.target.files[0] }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.MessageContentMessagesFilterRange, error: error, statusCode: response?.statusCode, message: "MessageContentMessagesFilterRange " + error.message, level: 2, component: "Messages", line: 24 }))
                } else {
                    addIcon(resdata);
                }
            })
        }
    }

    return <div>
        <BackArrow onClick={onClose}></BackArrow>
        <div className={classes.Add}>
            <BtnSelect checked={true} dropStyle={{ width: "114px", height: "30px" }}>{texts.addLibary}</BtnSelect>
            <input className={classes.InputFile} type="file" onChange={handleIconUpload} />
        </div>
        <div className={classes.IconsWrap}>{icons && icons.map(x =>
            <div
                className={classes.Icon}
                style={{ backgroundImage: `url(${x.icon})` }}
                onClick={() => { handleClick(x) }}>
            </div>)}
        </div>
    </div>
}

export default IconsSelect;